import { BookConsultationCard } from '@/features/programs/shared/ui/BookConsultationCard';
import {
    ActiveConsultationDto,
    ArticleDto,
    MenopauseProgramType,
    ProductCardViewModel,
} from '@/features/programs/model/types';
import { CaregiverRoleEnum } from '@/shared/enums';
import { getTimedGreeting } from '@/shared/timedGreeting';
import { UpcomingConsultation } from '@/features/programs/shared/ui/UpcomingConsultation';
import { BackButton } from '@/components';
import { ArticlesGrid } from '@/features/programs/shared/ui/ArticleGrid';
import { R } from '@/features/programs/resources/ProgramsResources.resx';

export interface MenopauseProgramProps {
    productCardViewModels: ProductCardViewModel[];
    menopauseProgram: MenopauseProgramType;
    upcomingConsultation?: ActiveConsultationDto;
    articles?: ArticleDto[];
}

export const MenopauseProgram = ({
    productCardViewModels,
    menopauseProgram,
    upcomingConsultation,
    articles,
}: MenopauseProgramProps) => {
    return (
        <>
            <div className="content-grid">
                <div className="content-grid-full bg-action-orange-extralight relative overflow-hidden">
                    <div className="flex w-full flex-col items-center gap-6 px-4 md:px-10 lg:h-80 lg:flex-row lg:items-end">
                        {/* LEFT CONTENT */}
                        <div className="h-full w-full lg:w-[calc(50%+3rem)] lg:pt-2">
                            <div className="w-full flex-col items-end justify-center gap-4 lg:ml-auto lg:h-80 lg:max-w-[660px]">
                                <div className="mx-2 mb-4 flex w-full justify-start">
                                    <BackButton />
                                </div>
                                <h4 className="text-action-orange mt-4 mb-2 px-4 text-center text-[18px] lg:text-left">
                                    SundOvergang
                                </h4>

                                <h2 className="px-4 text-center text-[32px] lg:text-left">
                                    {getTimedGreeting(
                                        menopauseProgram.ProfileName,
                                    )}
                                </h2>
                            </div>
                        </div>

                        {/* MAIN IMAGE */}
                        <div className="z-0 flex w-full justify-center lg:ml-[100px] lg:w-[calc(50%-3rem)] lg:justify-start">
                            <img
                                className=""
                                src={menopauseProgram.MainImagePath}
                                width={300}
                                alt=""
                                aria-hidden
                            />
                        </div>
                    </div>

                    <img
                        className="pointer-events-none absolute bottom-0 left-0 z-10 h-[50px] w-full md:h-[88px]"
                        src="/images/icons_shape/hero-background-mask.svg"
                        alt=""
                    />
                </div>

                {upcomingConsultation && (
                    <UpcomingConsultation
                        upcomingConsultation={upcomingConsultation}
                    />
                )}

                <div
                    className={`relative z-20 ${upcomingConsultation ? 'mt-6' : '-mt-[30px] md:-mt-[68px]'} flex max-w-[1440px] flex-wrap justify-center gap-4`}
                >
                    {productCardViewModels.map((vm: ProductCardViewModel) => (
                        <div
                            key={`${CaregiverRoleEnum[vm.CardDto.Role]}`}
                            className="flex basis-full justify-center md:basis-[calc(50%-0.5rem)]"
                        >
                            <BookConsultationCard
                                productCard={vm}
                                showTags={true}
                                className="relative z-20 mb-8 h-full min-h-[236px] w-full md:max-w-[540px] lg:max-w-[720px]"
                            />
                        </div>
                    ))}
                </div>
            </div>
            <div className="mt-10 w-screen bg-gray-100">
                <div className="mx-auto max-w-[1440px] px-4 md:px-10">
                    <p className="text-font-body pt-10 font-bold text-gray-800">
                        {R.ArticlesHeader}
                    </p>
                    <ArticlesGrid articles={articles} />
                </div>
            </div>
        </>
    );
};
